import { render, staticRenderFns } from "./PageScripts.vue?vue&type=template&id=77510332&"
import script from "./PageScripts.vue?vue&type=script&lang=ts&"
export * from "./PageScripts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports